import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "login-area pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = { class: "form-title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-12" }
const _hoisted_12 = { class: "form-inner mb-25" }
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = { class: "title fw-bold" }
const _hoisted_15 = { class: "col-lg-12" }
const _hoisted_16 = { class: "form-inner" }
const _hoisted_17 = {
  key: 1,
  class: "primry-btn-2",
  type: "button"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.sessionData)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(_ctx.sessionData) + "!", 1))
                  : (_openBlock(), _createElementBlock("h3", _hoisted_8, "Resend Email Link!")),
                _hoisted_9
              ]),
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, [
                          _createTextVNode("Email: "),
                          _createElementVNode("h5", null, _toDisplayString(JSON.parse(_ctx.currentUser)[0].email), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (!this.isLoading)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resendEmail && _ctx.resendEmail(...args))),
                            class: "primry-btn-2",
                            type: "button"
                          }, " Send verification request again "))
                        : (_openBlock(), _createElementBlock("button", _hoisted_17, _hoisted_20))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}